export enum SlateLayout {
  CLASSIC = 'CLASSIC',
  DEFAULT = 'DEFAULT',
}
